export function scheduleAfterPaint(callback) {
  if (typeof window === 'undefined') {
    callback()
    return () => {}
  }

  let cancelled = false
  const run = () => {
    if (!cancelled) callback()
  }

  const frameId = window.requestAnimationFrame(() => {
    window.requestAnimationFrame(run)
  })

  return () => {
    cancelled = true
    window.cancelAnimationFrame(frameId)
  }
}

export function scheduleIdleTask(callback, { timeout = 1200 } = {}) {
  if (typeof window === 'undefined') {
    callback()
    return () => {}
  }

  let cancelled = false
  const run = () => {
    if (!cancelled) callback()
  }

  if (typeof window.requestIdleCallback === 'function') {
    const idleId = window.requestIdleCallback(run, { timeout })
    return () => {
      cancelled = true
      window.cancelIdleCallback(idleId)
    }
  }

  const timerId = window.setTimeout(run, 0)
  return () => {
    cancelled = true
    window.clearTimeout(timerId)
  }
}
